var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layerWrapper active",
      staticStyle: { display: "block" },
      attrs: { tabindex: "0" }
    },
    [
      _c(
        "div",
        {
          ref: "layerBox",
          staticClass: "cbox layerBox popWidM",
          style: Object.assign(
            {},
            { display: "block", opacity: "1" },
            _vm.style
          )
        },
        [
          _c("div", { staticClass: "cart-popup__dialog" }, [
            _c("div", { staticClass: "cart-popup__content payment" }, [
              _c(
                "div",
                {
                  staticClass: "cart-popup__item-info amway-theme",
                  staticStyle: { padding: "0" }
                },
                [
                  _vm.wave_number === 1
                    ? _c("div", [
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_01-1.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_01-2.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_01-3.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_01-4.jpg"),
                            alt: "액티비티 안내"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.wave_number === 2
                    ? _c("div", [
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_02-1.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_02-2.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_02-3.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_02-4.jpg"),
                            alt: "액티비티 안내"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.wave_number === 3
                    ? _c("div", [
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_03-1.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_03-2.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_03-3.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_03-4.jpg"),
                            alt: "액티비티 안내"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.wave_number === 4
                    ? _c("div", [
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_04-1.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_04-2.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_04-3.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_04-4.jpg"),
                            alt: "액티비티 안내"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.wave_number === 5
                    ? _c("div", [
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_05-1.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_05-2.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_05-3.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_05-4.jpg"),
                            alt: "액티비티 안내"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.wave_number === 6
                    ? _c("div", [
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_06-1.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_06-2.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_06-3.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_06-4.jpg"),
                            alt: "액티비티 안내"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.wave_number === 7
                    ? _c("div", [
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_07-1.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_07-2.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_07-3.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_07-4.jpg"),
                            alt: "액티비티 안내"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.wave_number === 8
                    ? _c("div", [
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_08-1.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_08-2.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_08-3.jpg"),
                            alt: "액티비티 안내"
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/views/surveys/sydney/images/activity/activity_sdy_08-4.jpg"),
                            alt: "액티비티 안내"
                          }
                        })
                      ])
                    : _vm._e()
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cart-popup__item-link",
                staticStyle: { border: "none" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "bt-akl-blue btn_close NCAcmi_cont03_popup",
                    on: { click: _vm.closePopup }
                  },
                  [_vm._v("확인")]
                )
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-462473cc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-462473cc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/sydney/components/SurveyPopupLayerActivity.vue
// module id = null
// module chunks = 